import React, { FC } from 'react';
import { Empty as AntdEmpty } from 'antd';
import { EmptyProps } from 'antd/lib/empty';

export const Empty: FC<EmptyProps> = (props) => {
  return <AntdEmpty {...props} />;
};

export default Empty;
